module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"departments":"Nasze oddziały"},"en":{"departments":"Our branches"}}')
  delete Component.options._Ctor
}
